import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { EScolaMaterial } from 'src/app/domain/enums/scola-material';
import { MPCA } from 'src/app/domain/mpca';

import { StringTool } from '../../mapping/string.tool';
import { StringConverter } from '../string-converter';
import { EDegradationLevel } from 'src/app/domain/enums/degradation-level';
import { MatDialogRef } from '@angular/material/dialog';
import { MaterielAdduction } from 'src/app/domain/Adduction-air/materiel-adduction';
import { ETypePrelevementAir } from 'src/app/domain/Adduction-air/enum/type-prelevement-air';
import { ETypeMaterielAdductionAir } from 'src/app/domain/Adduction-air/enum/type-materiel';

@Component({
    selector: 'adduction-materiel-box',
    templateUrl: 'adduction-materiel-box.html',
    styleUrls: ['./adduction-materiel-box.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class AdductionMaterielBoxDialog implements OnInit {

    Model: MaterielAdduction = new MaterielAdduction();
 
    public MaterielAdductionList: string[] = Object.values(ETypeMaterielAdductionAir)
        .filter(x => !isNaN(Number(x)))
        .map((x: any) => StringConverter.getTypeMaterielAdductionAirName(x));

    constructor(
        public dialogRef: MatDialogRef<AdductionMaterielBoxDialog>) {

    }

    ngOnInit() {
    }

    canFinish() {
        return StringTool.isNotNullOrEmpty(this.Model.Fabricant) && this.Model.MaterielCompresseur.ReferenceHuile && StringTool.isNotNullOrEmpty(this.Model.Reference);
    }

    onCancel() {
        this.dialogRef.close();
    }

    finish() {
        if (!this.canFinish()) {
            return;
        }
        this.dialogRef.close(this.Model);
    }
}
